<template>
  <div class="content">
    <div class="white-bg left-panel flex-column">
      <el-avatar
        :size="72"
        icon="el-icon-user-solid"
        :src="user.icon"
      ></el-avatar>
      <span>{{ user.name }}</span>

      <span class="h-line" />
      <div class="links flex-column">
        <template v-for="l in leftLinks" >
          <template v-if="data">
            <router-link
              class="link whitespace-nowrap"
              active-class="cur"
              :to="l.url"
              :key="l.url"
           
              
            >
              <!-- <span v-if="data.is_sup">{{data.is_sup}}</span> -->
              <span class="iconfont" :class="l.icon"></span>
              <span>{{ $t(l.title) }}</span>
            </router-link>
          </template>
        </template>
      </div>
    </div>
    <div class="right-panel  bg-white p-8">
      <router-view></router-view>
    </div>
  </div>
</template>

<script>
import { computed, ref} from "@vue/composition-api";

export default {
  components: {},
  setup(props, ctx) {
    const leftLinks = computed(() => [
      {
        title: ctx.root.$t("个人中心"),
        url: "/mine/center",
        icon: "icon-gerenzhongxin",
      },
      { title: ctx.root.$t("我的订单"), url: "/mine/order/", icon: "icon-dingdan" },
      {
        title: ctx.root.$t("我的购物车"),
        url: "/mine/cart/",
        icon: "icon-cart",
      },
      { title: ctx.root.$t("我的消息"), url: "/mine/message/", icon: "icon-tongzhi" },
      { title: ctx.root.$t("收货地址"), url: "/mine/address", icon: "icon-shouhuodizhi" },
      { title: ctx.root.$t("我的钱包"), url: "/mine/wallet/", icon: "icon-qianbao" },
      { title: ctx.root.$t("我的收藏"), url: "/mine/favorite/", icon: "icon-shoucang" },
      data.value?.is_sup===1 &&{ title: ctx.root.$t("商品管理"), url: "/mine/supplierproducts/", icon: "icon-gonghuoshangshangpin" },
      data.value?.is_sup === 1 && { title: ctx.root.$t("供货商订单"), url: "/mine/supplierorder/", icon: "icon-gonghuoshangdingdan" },
      data.value?.is_sup===1 && { title: ctx.root.$t("收款信息"), url: "/mine/payinfo", icon: "icon-shoukuan" },
    ].filter(o => o));

    const user = computed(() => ctx.root.$store.getters.user);
    const data = ref();

    const isSupplier = async() => {
    // onMounted(async () => {
    // watchEffect(async() => {
      const res = await ctx.root.$callapi("sup/isSup", {
      });
      if(res.data){
         data.value = res.data;
      }
      
      // console.log(1111111)
      // console.log(data.value.is_sup)
      // console.log(1111111)
    };
    isSupplier();

    return { leftLinks, user, data};
  },
};
</script>
<style scoped lang="scss">
@import "@/style/theme.scss";
.content {
  width: 100%;
  display: grid;
  grid-template-columns: 1.1fr 5fr;
  grid-column-gap: $panel-margin;
}
.left-panel {
  background: white;
  padding: 30px 0;
  min-height: 700px;
  align-items: center;
}
.left-panel .user-info .avatar {
  width: 72px;
  height: 72px;
  border-radius: 50%;
  border: 1px solid $main-color;
}
.left-panel .h-line {
  width: 80%;
  margin: 20px 0;
}
.left-panel .links {
  width: 100%;
  text-align: left;
}
.left-panel .links .link {
  color: black;
  text-decoration: none;
  margin: 10px 0;
  padding-left: 50px;
  border-left: 2px solid white;
}
.left-panel .links .link .iconfont {
  display: inline-block;
  margin-right: 12px;
  width: 10px;
}
.left-panel .links .link.cur {
  border-left-color: $main-color;
  color: $main-color;
}
.left-panel .links .link:hover {
  color: $main-color;
}
</style>
